/**
 * ConflictBanner Component
 * 
 * Displays error banner when active segments overlap or other conflicts are detected.
 */

import React from 'react';
import { Conflict } from '../../types/menuPlanning';
import { formatDuration } from '../../utils/scheduler';
import '../../styles/menuPlanning.css';

interface ConflictBannerProps {
  conflicts: Conflict[];
  onClose: () => void;
}

export const ConflictBanner: React.FC<ConflictBannerProps> = ({ conflicts, onClose }) => {
  if (conflicts.length === 0) return null;

  const renderConflictMessage = (conflict: Conflict) => {
    if (conflict.type === 'order_violation') {
      return conflict.message || 'Step order violation detected';
    }

    const recipe1 = conflict.segment1.recipeName || `Recipe ${conflict.segment1.recipeId}`;
    const recipe2 = conflict.segment2.recipeName || `Recipe ${conflict.segment2.recipeId}`;
    
    return `Active conflict: "${recipe1}" and "${recipe2}" overlap by ${formatDuration(conflict.overlapSec)}`;
  };

  return (
    <div className="conflict-banner">
      <div className="conflict-banner-message">
        <strong>⚠️ {conflicts.length} Conflict{conflicts.length > 1 ? 's' : ''} Detected</strong>
        <div style={{ marginTop: '8px', fontSize: '11px' }}>
          {conflicts.slice(0, 3).map((conflict, idx) => (
            <div key={idx}>{renderConflictMessage(conflict)}</div>
          ))}
          {conflicts.length > 3 && (
            <div>... and {conflicts.length - 3} more</div>
          )}
        </div>
      </div>
      <button
        className="conflict-banner-close"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
};

export default ConflictBanner;


